import { useContext } from "react";

import WineClubsContext, {
  WineClubsContextInterface,
} from "../../contexts/wine-clubs/context";

export const usePlanContext = (): WineClubsContextInterface =>
  useContext(WineClubsContext);
